import React from 'react';
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Label, Input, Button, UncontrolledDropdown, DropdownMenu, DropdownItem, DropdownToggle, CustomInput,Form, FormText, FormGroup  } from 'reactstrap';
import { toast } from 'components/Shared/Toast'
import bootbox from 'components/Modals/Bootbox'
function DesignSystem() {

    function showModal(){
        toast.success('Success notiﬁcation Subtitle text goes here.',);
        toast.info('Informational notiﬁcation Subtitle text goes here.',);
        toast.warning('Warning notiﬁcation Subtitle text goes here.',);
        toast.error('Error notiﬁcation Subtitle text goes here.',);
        bootbox.alert('Modal')
        toast.success('Success notiﬁcation Subtitle text goes here.',);
        toast.info('Informational notiﬁcation Subtitle text goes here.',);
        toast.warning('Warning notiﬁcation Subtitle text goes here.',);
        toast.error('Error notiﬁcation Subtitle text goes here.',);
    }
    return (
        <Container fluid>
  <Row>
    <Col md={2}>
       Sidebar content
    </Col>
    <Col md={9}>
    <h1>Design System TRATO.IO</h1>
            <Row>
                <Col md="12" className="h-100">
                    <div className="border p-4">
                        <h2>Headings</h2>
                        <h1>h1. This is for layout headings</h1>
                        <h2>h2. This is for layout headings</h2>
                        <h3>h3. This is for layout headings</h3>
                        <h4>h4. This is for layout headings</h4>
                        <h5>h5. This is for component and layout headings</h5>
                        <h6>h6. This is for component and layout headings</h6>
                        <span className="h7">h7. This is for component and layout headings</span>
                    </div>

                    {/*
                    <div className="border p-4 mt-2">
                        <h2></h2>
                    </div>
                    */}

                    <div className="border p-4 mt-2">
                        <p className="body-short-01">This is for short paragraphs with no more than 4 lines and is commonly used in components.</p>
                        <p className="body-long-01">This is commonly used in both the Expressive and the Productive type theme layouts for long paragraphs with more than four lines. It is a good size for comfortable, long-form reading. We also use this for longer body copy in components such as Accordion or Structured List. We always left-align this type; we never center it.</p>
                        <p className="body-short-02">This is for short paragraphs with no more than 4 lines and is commonly used in the expressive type theme for layouts.</p>
                        <p className="body-long-02">This is commonly used in the expressive type theme layouts for long paragraphs with more than four lines. The looser line height and larger size makes for comfortable, long-form reading, in mediums that allow for more space. This size type is rarely used for body copy in components. We always left-align type; we never center it.</p>
                    </div>
                    
                    
                    <div className="p-3 mb-2 white">indigo-10</div>
                    <div className="p-3 mb-2 indigo-10">indigo-10</div>
                    <div className="p-3 mb-2 indigo-20">indigo-20</div>
                    <div className="p-3 mb-2 indigo-30">indigo-30</div>
                    <div className="p-3 mb-2 indigo-40">indigo-40</div>
                    <div className="p-3 mb-2 indigo-50">indigo-50</div>
                    <div className="p-3 mb-2 indigo-60">indigo-60</div>
                    <div className="p-3 mb-2 indigo-70">indigo-70</div>
                    <div className="p-3 mb-2 indigo-80">indigo-80</div>
                    <div className="p-3 mb-2 indigo-100">indigo-100</div>
                    <div className="p-3 mb-2 indigo-10-hover">indigo-10-hover</div>
                    <div className="p-3 mb-2 indigo-20-hover">indigo-20-hover</div>
                    <div className="p-3 mb-2 indigo-80-hover">indigo-80-hover</div>
                    <div className="p-3 mb-2 orange-20">orange-20</div>
                    <div className="p-3 mb-2 orange-40">orange-40</div>
                    <div className="p-3 mb-2 orange-50">orange-50</div>
                    <div className="p-3 mb-2 orange-60">orange-60</div>
                    <div className="p-3 mb-2 orange-70">orange-70</div>
                    <div className="p-3 mb-2 orange-80">orange-80</div>
                    <div className="p-3 mb-2 orange-60-hover">orange-60-hover</div>
                    <div className="p-3 mb-2 orange-70-hover">orange-70-hover</div>
                    <div className="p-3 mb-2 red-50">red-50</div>
                    <div className="p-3 mb-2 red-60">red-60</div>
                    <div className="p-3 mb-2 red-60-hover">red-60-hover</div>
                    <div className="p-3 mb-2 red-80">red-80</div>
                    <div className="p-3 mb-2 green-40">green-40</div>
                    <div className="p-3 mb-2 green-50">green-50</div>
                    <div className="p-3 mb-2 yellow">yellow</div>
                    <div className="p-3 mb-2 purple-60">purple-60</div>


                    <hr></hr>
                    
                    <Form>
                        <Row form>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="exampleEmail">Label</Label><br/>
                                    <Label for="exampleEmail">Label</Label>
                                    <Input type="email" name="email" id="exampleEmail" placeholder="Placeholder text" />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleText">Label</Label>
                                    <Input type="textarea" name="text" id="exampleText"  placeholder="Placeholder text"  />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="exampleSelect">Label</Label>
                                    <Input type="select" name="select"  placeholder="Placeholder text" >
                                    <option>Choose an option</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                    <option>5</option>
                                    </Input>
                                </FormGroup>
                                <FormGroup>
                                    <Label for="examplePassword">Label</Label>
                                    <Input type="number" name="password" id="examplePassword"  placeholder="Placeholder text" />
                                </FormGroup>
                                <FormGroup>
                                    <CustomInput type="checkbox" id="exampleCustomCheckbox" label="Checkbox item"/>
                                    <CustomInput type="checkbox" id="exampleCustomCheckbox" label="Checkbox item"/>
                                </FormGroup>
                                <FormGroup>
                                    <CustomInput type="radio" id="exampleCustomCheckbox" label="Radio button item"/>
                                    <CustomInput type="radio" id="exampleCustomCheckbox" label="Radio button item"/>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                    <hr></hr>
                    <Row>
                        <Col lg="12">
                            <Button color="primary">Primary Button</Button><br/><br/>
                            <Button color="primary" disabled>Primary Button</Button><br/><br/>
                            <Button color="primary">Primary Button <i class="fas fa-plus"></i></Button><br/>
                            <Button color="primary"><i class="fas fa-plus"></i></Button>

                            <Button color="secondary" disabled>Secondary Button</Button>
                            <Button color="secondary">Secondary Button <i class="fas fa-plus"></i></Button>
                            <Button color="secondary"><i class="fas fa-plus"></i></Button>
                        </Col>
                    </Row>
                    <hr></hr>

                    <div className="border p-4 mt-2">
                        <h2>Breadcrum</h2>
                        <div>
                            <Breadcrumb>
                                <BreadcrumbItem active>Home</BreadcrumbItem>
                            </Breadcrumb>
                            <Breadcrumb>
                                <BreadcrumbItem><a href="#">Home</a></BreadcrumbItem>
                                <BreadcrumbItem active>Library</BreadcrumbItem>
                            </Breadcrumb>
                            <Breadcrumb>
                                <BreadcrumbItem><a href="#">Home</a></BreadcrumbItem>
                                <BreadcrumbItem><a href="#">Library</a></BreadcrumbItem>
                                <BreadcrumbItem>Data</BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                    </div>
                </Col>

                <Col md="6" className="ml-3">
                    <Row>
                        <Button color="primary" onClick={showModal} className="w-50 pt-4 pb-5 text-left">Show Modals</Button>{' '}
                        <Button color="secondary" className="w-50 pt-4 pb-5 text-left">Save</Button>{' '}
                    </Row>
                </Col>
            </Row>

            <Row className="ml-1">
                <UncontrolledDropdown>
                    <DropdownToggle caret>
                        Dropdown
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem header>Header</DropdownItem>
                        <DropdownItem disabled>Action</DropdownItem>
                        <DropdownItem>Another Action</DropdownItem>
                        <DropdownItem>Another Action</DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown> 
            </Row>
            <hr></hr>
            <hr></hr>
            <Col>
                <Form>
                    <FormGroup>
                        <Label for="exampleEmail">Email</Label>
                        <Input type="email" name="email" id="exampleEmail" placeholder="with a placeholder" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Input type="password" name="password" id="examplePassword" placeholder="password placeholder" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleSelect">Select</Label>
                        <Input type="select" name="select" id="exampleSelect">
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleSelectMulti">Select Multiple</Label>
                        <Input type="select" name="selectMulti" id="exampleSelectMulti" multiple>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleText">Text Area</Label>
                        <Input type="textarea" name="text" id="exampleText" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleFile">File</Label>
                        <Input type="file" name="file" id="exampleFile" />
                        <FormText color="muted">
                        This is some placeholder block-level help text for the above input.
                        It's a bit lighter and easily wraps to a new line.
                        </FormText>
                    </FormGroup>
                    <FormGroup tag="fieldset">
                        <legend>Radio Buttons</legend>
                        <FormGroup check>
                        <Label check>
                            <Input type="radio" name="radio1" />{' '}
                            Option one is this and that—be sure to include why it's great
                        </Label>
                        </FormGroup>
                        <FormGroup check>
                        <Label check>
                            <Input type="radio" name="radio1" checke />{' '}
                            Option two can be something else and selecting it will deselect option one
                        </Label>
                        </FormGroup>
                        <FormGroup check disabled>
                        <Label check>
                            <Input type="radio" name="radio1" disabled />{' '}
                            Option three is disabled
                        </Label>
                        </FormGroup>
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                        <Input type="checkbox" />{' '}
                        Check me out
                        </Label>
                    </FormGroup>
                    <Button>Submit</Button>
                </Form>
                <hr></hr>            
                <Form>
                    <FormGroup>
                        <Label for="exampleEmail">Plain Text (Static)</Label>
                        <Input plaintext value="Some plain text/ static value" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleEmail">Email</Label>
                        <Input
                        type="email"
                        name="email"
                        id="exampleEmail"
                        placeholder="with a placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Input
                        type="password"
                        name="password"
                        id="examplePassword"
                        placeholder="password placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleUrl">Url</Label>
                        <Input
                        type="url"
                        name="url"
                        id="exampleUrl"
                        placeholder="url placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleNumber">Number</Label>
                        <Input
                        type="number"
                        name="number"
                        id="exampleNumber"
                        placeholder="number placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleDatetime">Datetime</Label>
                        <Input
                        type="datetime"
                        name="datetime"
                        id="exampleDatetime"
                        placeholder="datetime placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleDate">Date</Label>
                        <Input
                        type="date"
                        name="date"
                        id="exampleDate"
                        placeholder="date placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleTime">Time</Label>
                        <Input
                        type="time"
                        name="time"
                        id="exampleTime"
                        placeholder="time placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleColor">Color</Label>
                        <Input
                        type="color"
                        name="color"
                        id="exampleColor"
                        placeholder="color placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleSearch">Search</Label>
                        <Input
                        type="search"
                        name="search"
                        id="exampleSearch"
                        placeholder="search placeholder"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleSelect">Select</Label>
                        <Input type="select" name="select" id="exampleSelect">
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleSelectMulti">Select Multiple</Label>
                        <Input
                        type="select"
                        name="selectMulti"
                        id="exampleSelectMulti"
                        multiple
                        >
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleText">Text Area</Label>
                        <Input type="textarea" name="text" id="exampleText" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleFile">File</Label>
                        <Input type="file" name="file" id="exampleFile" />
                        <FormText color="muted">
                        This is some placeholder block-level help text for the above input.
                        It's a bit lighter and easily wraps to a new line.
                        </FormText>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleRange">Range</Label>
                        <Input type="range" name="range" id="exampleRange" />
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                        <Input type="radio" /> Option one is this and that—be sure to
                        include why it's great
                        </Label>
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                        <Input type="checkbox" /> Check me out
                        </Label>
                    </FormGroup>
                </Form>
                <Form>
                    <FormGroup>
                        <Label for="exampleCheckbox">Checkboxes</Label>
                        <div>
                        <CustomInput type="checkbox" id="exampleCustomCheckbox" label="Check this custom checkbox" />
                        <CustomInput type="checkbox" id="exampleCustomCheckbox2" label="Or this one" />
                        <CustomInput type="checkbox" id="exampleCustomCheckbox3" label="But not this disabled one" disabled checked />
                        <CustomInput type="checkbox" id="exampleCustomCheckbox4" label="Can't click this label to check!" htmlFor="exampleCustomCheckbox4_X" disabled />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCheckbox">Radios</Label>
                        <div>
                        <CustomInput type="radio" id="exampleCustomRadio" name="customRadio" label="Select this custom radio" />
                        <CustomInput type="radio" id="exampleCustomRadio2" name="customRadio" label="Or this one" />
                        <CustomInput type="radio" id="exampleCustomRadio3" label="But not this disabled one" disabled checked />
                        <CustomInput type="radio" id="exampleCustomRadio4" label="Can't click this label to select!" htmlFor="exampleCustomRadio4_X" disabled />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCheckbox">Switches</Label>
                        <div>
                        <CustomInput type="switch" id="exampleCustomSwitch" name="customSwitch" label="Turn on this custom switch" />
                        <CustomInput type="switch" id="exampleCustomSwitch2" name="customSwitch" label="Or this one" />
                        <CustomInput type="switch" id="exampleCustomSwitch3" label="But not this disabled one" disabled checked/>
                        <CustomInput type="switch" id="exampleCustomSwitch4" label="Can't click this label to turn on!" htmlFor="exampleCustomSwitch4_X" disabled />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCheckbox">Inline</Label>
                        <div>
                        <CustomInput type="checkbox" id="exampleCustomInline" label="An inline custom input" inline />
                        <CustomInput type="checkbox" id="exampleCustomInline2" label="and another one" inline />
                        </div>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomSelect">Custom Select</Label>
                        <CustomInput type="select" id="exampleCustomSelect" name="customSelect">
                        <option value="">Select</option>
                        <option>Value 1</option>
                        <option>Value 2</option>
                        <option>Value 3</option>
                        <option>Value 4</option>
                        <option>Value 5</option>
                        </CustomInput>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomMutlipleSelect">Custom Multiple Select</Label>
                        <CustomInput type="select" id="exampleCustomMutlipleSelect" name="customSelect" multiple>
                        <option value="">Select</option>
                        <option>Value 1</option>
                        <option>Value 2</option>
                        <option>Value 3</option>
                        <option>Value 4</option>
                        <option>Value 5</option>
                        </CustomInput>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomSelectDisabled">Custom Select Disabled</Label>
                        <CustomInput type="select" id="exampleCustomSelectDisabled" name="customSelect" disabled>
                        <option value="">Select</option>
                        <option>Value 1</option>
                        <option>Value 2</option>
                        <option>Value 3</option>
                        <option>Value 4</option>
                        <option>Value 5</option>
                        </CustomInput>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomMutlipleSelectDisabled">Custom Multiple Select Disabled</Label>
                        <CustomInput type="select" id="exampleCustomMutlipleSelectDisabled" name="customSelect" multiple disabled>
                        <option value="">Select</option>
                        <option>Value 1</option>
                        <option>Value 2</option>
                        <option>Value 3</option>
                        <option>Value 4</option>
                        <option>Value 5</option>
                        </CustomInput>
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomRange">Custom Range</Label>
                        <CustomInput type="range" id="exampleCustomRange" name="customRange" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomFileBrowser">File Browser</Label>
                        <CustomInput type="file" id="exampleCustomFileBrowser" name="customFile" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomFileBrowser">File Browser with Custom Label</Label>
                        <CustomInput type="file" id="exampleCustomFileBrowser" name="customFile" label="Yo, pick a file!" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="exampleCustomFileBrowser">File Browser Disabled</Label>
                        <CustomInput type="file" id="exampleCustomFileBrowser" name="customFile" disabled />
                    </FormGroup>
                </Form>
            </Col>

            <Col>
                <Button color="primary">primary</Button>{' '}
                <Button color="secondary">secondary</Button>{' '}
                <Button color="success">success</Button>{' '}
                <Button color="info">info</Button>{' '}
                <Button color="warning">warning</Button>{' '}
                <Button color="danger">danger</Button>{' '}
                <Button color="link">link</Button>
            </Col>
            <hr></hr>
            <hr></hr>
            <hr></hr>
    </Col>
  </Row>
</Container>
    )
}

export default DesignSystem;
